
export interface Environment {
  accountService: string;
  appDomain: string;
  authKey: string;
  consumerPrivacyUrl: string;
  demandBase: string;
  environment: string;
  production: boolean;
  env: ENV;
  image: string;
  domain: string;
  magento: string;
  dpo: string;
  dpoDownloadables: string;
  dpoV3: string;
  dpoV4: string;
  dpoV5: string;
  deploymentId: string;
  ssoService: string;
}
export interface Config {
  authKey: string;
  env: string;
  recaptchaKey: string;
  recaptchaSecret: string;
  theme: {
    cookieKey: string;
    modes: {
      default: {
        landingPage: string;
        toggleLabel: string;
      },
      industrial: {
        landingPage: string;
        toggleLabel: string;
        URLregex: RegExp,
      },
    },
  },
  version: '1.0.0',
}

export type ENV =
  | 'test'
  | 'sanbox'
  | 'development'
  | 'staging'
  | 'bkp'
  | 'live'
  | 'production';
